import SidebarBookingsIdentityRoute from 'uplisting-frontend/pods/-sidebar/bookings/identity/route';

export default class ProtectionOverviewBookingsIdentityRoute extends SidebarBookingsIdentityRoute {
  parentRoute = 'protection.overview.bookings';
}
